import React from "react";
import { BigNumber } from "ethers";

export type HiveContextValue = {
  hiveBalanceInTokens?: Record<number, BigNumber>;
  hiveBalanceInTokensSum?: BigNumber;
  readHiveBalanceInTokens: () => void;
};

const HiveContext = React.createContext<HiveContextValue>({
  readHiveBalanceInTokens: () => {},
});

export default HiveContext;
